import { useEffect, useRef, useState } from 'react';
import './orgPackUpload.css';
import Itinerary from '../../components/packUploadSection/itinerary/Itinerary';
import Tags from '../../components/tags/Tags';
import FAQ from '../../components/packUploadSection/FAQ/FAQ';
import Price from '../../components/packUploadSection/price/Price';
import QuickView from '../../components/packUploadSection/quickView/QuickView';
import Basic from '../../components/packUploadSection/basic/Basic';
import ImageUpOrg from '../../components/packUploadSection/images/ImageUpOrg';
import InEx from '../../components/packUploadSection/inEx/InEx';
import orgPackUpSubmit from './orgPackUpFun/orgPackUpSubmit';
import StaySection from '../../components/staySection/StaySection';
import ReactLoading from 'react-loading';
import Terms from './orgPackUploadSection/terms/Terms';
import errorHandle from '../../utils/errorHandle';
import { getDropdownFun } from '../../api/infoAPI';
import { useLocation, useNavigate } from 'react-router-dom';
import BackIcon from '../../assets/icons/trvto_ArrowBack.svg';
import DownArrow from '../../assets/icons/down-arrow.svg';
import UpArrow from '../../assets/icons/up-arrow.svg';
import Safety from './orgPackUploadSection/safety/safety';
import ThingsToCarry from './orgPackUploadSection/thingsToCarry/thingsToCarry';
import { orgTripDetailsFun } from '../../api/orgTripAPI';

export default function OrgPackUpload() {
    const navigate = useNavigate();
    const location = useLocation();
    const submitRef = useRef(null);

    const basicRef = useRef(null);
    const quickViewRef = useRef(null);
    const itineraryRef = useRef(null);
    const imageRef = useRef(null);
    const inExRef = useRef(null);
    const safetyRef = useRef(null);
    const thingsRef = useRef(null);
    const faqRef = useRef(null);
    const termsRef = useRef(null);
    const priceRef = useRef(null);
    const tagsRef = useRef(null);

    const searchParams = new URLSearchParams(location.search);
    const [scroll, setScroll] = useState(false);
    const newPack = searchParams.get('new') === 'false';
    const type = searchParams.get('type');
    const tripId = searchParams.get('tripId');
    const [packData, setPackData] = useState({
        _id: '',
        status: '',
        title: '',
        overview: '',
        days: null,
        nights: null,
        quickView: {
            type: [],
            difficulty: '',
            startTime: '',
            endTime: '',
            duration: '',
            stay: '',
            where: '',
            food: '',
            trekDistance: '',
            baseCities: ''
        },
        itinerary: [
            {
                dayHeading: '',
                dayDescription: ''
            }
        ],
        group: '',
        itiType: '',
        datesType: '',
        FAQ: [{ question: '', answer: '' }],
        room: null,
        price: [
            {
                price: {
                    actual: null,
                    get tax() {
                        return Math.round(this.actual * 0.05);
                    },
                    get total() {
                        return Math.round(this.actual + this.tax + this.vehicle);
                    },
                    reserve: null,
                    higherPrice: null,
                    discountPer: null
                },
                customPrice: {
                    room: null,
                    bed: null,
                    perPerson: null,
                    vehicle: [],
                    reserve: null,
                    groupPrice: null
                },
                startCity: '',
                pickupLocation: [],
                meetupPoint: [],
                vehicle: [],
                instalments: []
            }
        ],
        withoutTransportPrice: null,
        tags: [],
        stayDetails: { name: '', location: '', mapLink: '', description: '', images: [] }
    });
    const [tempData, setTempData] = useState({
        included: '',
        excluded: '',
        terms: '',
        safety: '',
        carry: ''
    });
    const [imgData, setImgData] = useState({
        oldWallImg: [],
        oldThumbImg: [],
        newWallImg: [],
        newThumbImg: []
    });
    const [loading, setLoading] = useState(false);
    const [cityDrop, setCityDrop] = useState([
        { name: 'Bengaluru', displayName: 'Bengaluru/Bangalore' },
        { name: 'Mysuru', displayName: 'Mysuru/Mysore' }
    ]);
    const [isEdit, setIsEdit] = useState(false);
    const [videoFile, setVideoFile] = useState(null);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    // useEffect(() => {
    //     if (!location.state) return;
    //     setPackData(location.state);
    //     setImgData({
    //         oldWallImg: location.state.images,
    //         oldThumbImg: location.state.cardImages
    //     });
    //     setTempData({
    //         included: location.state.included?.join('\n'),
    //         excluded: location.state.excluded?.join('\n'),
    //         terms: location.state.terms?.join('\n'),
    //         safety: location.state.safety?.join('\n'),
    //         carry: location.state?.carry?.join('\n')
    //     });
    //     isDuplicate ? setIsEdit(false) : setIsEdit(true);
    //     //eslint-disable-next-line
    // }, [location.state]);

    useEffect(() => {
        async function getDropCity() {
            try {
                setLoading(true);
                const city = await getDropdownFun('trip', 'Base Cities');
                if (city.data) {
                    setCityDrop(city.data.dropdown);
                }
                setLoading(false);
            } catch (error) {
                errorHandle(error);
            }
        }
        getDropCity();
    }, []);

    useEffect(() => {
        if (newPack) {
            fetchPackData(tripId).then((data) => {
                setPackData(data);
                setImgData((prev) => ({
                    ...prev,
                    oldWallImg: data.images,
                    oldThumbImg: data.cardImages
                }));
                setVideoFile(data.videos[0] || null);
                setTempData({
                    included: data.included?.join('\n'),
                    excluded: data.excluded?.join('\n'),
                    terms: data.terms?.join('\n'),
                    safety: data.safety?.join('\n'),
                    carry: data?.carry?.join('\n')
                });
                type === 'duplicate' ? setIsEdit(false) : setIsEdit(true);
                if (type === 'duplicate') {
                    setImgData({
                        oldWallImg: [],
                        oldThumbImg: [],
                        newWallImg: [],
                        newThumbImg: []
                    });
                    setVideoFile(null);
                    setPackData((prevState) => ({
                        ...prevState,
                        room: null,
                        price: [
                            {
                                price: {
                                    actual: null,
                                    get tax() {
                                        return Math.round(this.actual * 0.05);
                                    },
                                    get total() {
                                        return Math.round(this.actual + this.tax + this.vehicle);
                                    },
                                    reserve: null,
                                    higherPrice: null,
                                    discountPer: null
                                },
                                customPrice: {
                                    room: null,
                                    bed: null,
                                    perPerson: null,
                                    vehicle: [],
                                    reserve: null,
                                    groupPrice: null
                                },
                                startCity: '',
                                pickupLocation: [],
                                meetupPoint: [],
                                vehicle: [],
                                instalments: []
                            }
                        ]
                    }));
                }
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }, [newPack, tripId, type]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;

            // Set scroll to true if user is not at top
            if (scrollTop > 3000) {
                setScroll(true);
            } else {
                setScroll(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up on unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    async function fetchPackData(id) {
        try {
            const result = await orgTripDetailsFun(id);
            return result.data;
        } catch (error) {
            errorHandle(error);
            return null;
        }
    }
    const handleSubmit = async () => {
        const res = await orgPackUpSubmit(packData, tempData, imgData, setLoading, isEdit, videoFile, {
            basicRef,
            quickViewRef,
            itineraryRef,
            imageRef,
            inExRef,
            safetyRef,
            thingsRef,
            faqRef,
            termsRef,
            priceRef,
            tagsRef
        });
        if (res === 200) {
            navigate('/org/my-pack');
        }
    };

    const handleScrollToSubmit = () => {
        if (submitRef.current) {
            submitRef.current.scrollIntoView({ behavior: 'smooth' });
            setScroll(true);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setScroll(false);
    };

    return (
        <>
            <div>
                <button className='backBtn' onClick={() => navigate('/org/my-pack')}>
                    <img src={BackIcon} alt='back' />
                    Back to Packages
                </button>
            </div>
            <div className='orgPackUpDiv'>
                {loading && (
                    <div className='loadingBackground'>
                        <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                        <h3 style={{ marginTop: -100, fontWeight: 700, color: '#9ca3af' }} className='loadingText'>
                            It might take several minutes please wait...
                        </h3>
                    </div>
                )}
                {isEdit && packData.status === 'active' && (
                    <div className='packEditNote'>
                        <p>
                            <span className='noteSpan'>Note:</span> Since the trip is approved, only certain parts of
                            the data can be edited.
                        </p>
                    </div>
                )}
                <div className='sticky-containerPack'>
                    {scroll ? (
                        <button onClick={scrollToTop} title='Scroll to bottom' className='sticky-button'>
                            <img src={UpArrow} alt='scroll to bottom' />
                        </button>
                    ) : (
                        <button onClick={handleScrollToSubmit} title='Scroll to bottom' className='sticky-button'>
                            <img src={DownArrow} alt='scroll to bottom' />
                        </button>
                    )}
                </div>
                <Basic ref={basicRef} packData={packData} setPackData={setPackData} isEdit={isEdit} />

                {/* //Small bold Information which contains slots, type, difficulty, start time, end time,
        // duration, stay, where, food, trek distance */}
                <QuickView ref={quickViewRef} packData={packData} setPackData={setPackData} />
                <Itinerary ref={itineraryRef} packData={packData} setPackData={setPackData} isEdit={isEdit} />
                <ImageUpOrg
                    ref={imageRef}
                    imgData={imgData}
                    setImgData={setImgData}
                    isEdit={isEdit}
                    videoFile={videoFile}
                    setVideoFile={setVideoFile}
                />
                <StaySection packData={packData} setPackData={setPackData} isEdit={isEdit} />
                <InEx ref={inExRef} tempData={tempData} setTempData={setTempData} isEdit={isEdit} packData={packData} />
                <Safety
                    ref={safetyRef}
                    tempData={tempData}
                    setTempData={setTempData}
                    isEdit={isEdit}
                    packData={packData}
                />
                <ThingsToCarry
                    ref={thingsRef}
                    tempData={tempData}
                    setTempData={setTempData}
                    isEdit={isEdit}
                    packData={packData}
                />
                <FAQ ref={faqRef} packData={packData} setPackData={setPackData} isEdit={isEdit} />
                <Terms ref={termsRef} tempData={tempData} setTempData={setTempData} />
                <Price
                    ref={priceRef}
                    packData={packData}
                    setPackData={setPackData}
                    cityDrop={cityDrop}
                    isEdit={isEdit}
                />
                <Tags
                    data={packData}
                    setData={setPackData}
                    note={`Topics - “Adventure“, "One day trip”, “Two days trip”, “Trek”, “Island”, “Mountains”,
                            “Beach”, “Road trip”, "Backpacking”, “Snow”, “Hike”.`}
                />

                <button ref={submitRef} type='button' className='orgPackUpSubmitBtn blueBtn' onClick={handleSubmit}>
                    Submit
                </button>
            </div>
        </>
    );
}
